<template>
  <div>
    <el-dialog
      title="生成报价单"
      :visible.sync="dialog"
      :width="getIsMobile?'100%':'70%'"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
      :append-to-body="true"
      class="dialog"
    >
      <el-table :data="list" border>
        <el-table-column label="序号" prop="">
          <template #default="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="型号" prop="xhname">
          <template #default="{ row }">
            <el-input v-model="row.xhname" type="text" placeholder="请输入型号"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="品牌" prop="source">
          <template #default="{ row }">
            <el-input v-model="row.source" type="text" placeholder="请输入品牌"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="数量" prop="num">
          <template #default="{ row,$index }">
            <el-input v-model.number="row.num" type="text" placeholder="请输入数量" class="{ 'input-error': errors[$index] }" @blur="validateRow($index, row.num)"></el-input>
            <span v-if="errors[$index]" class="error-text">数量为必填项</span>
          </template>
        </el-table-column>
        <el-table-column label="单价" prop="price">
          <template #default="{ row }">
            {{ row.price }}
          </template>
        </el-table-column>
        <el-table-column label="默认" prop="renshui">
          <template #default="{ row }">
            <!-- 选择百分比 -->
            <el-select v-model="row.renshui" @change="updatePrices(row)">
              <el-option v-for="item in percentOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="货期" prop="hq">
          <template #default="{ row }">
            <el-input v-model="row.hq" type="text" placeholder="请输入货期"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="bz">
          <template #default="{ row }">
            <el-input v-model="row.bz" type="text" placeholder="请输入备注"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="价格来源" prop="address" />
      </el-table>
      <el-button type="primary" style="margin-top: 8px" @click="openCompany">选择报价公司</el-button>
<!--       公司的一些信息-->
      <el-card v-if="showInfo" style="margin-top: 10px">
        <Info :companyInfo="companyInfo" @handleContact="getContact" :allInfo="allInfo" ref="infoRef" @handleFlag="handleFlag"/>
      </el-card>

      <el-button type="primary" style="margin-top: 8px" @click="printQuotation" v-if="showInfo">打印报价单</el-button>
    </el-dialog>
    <el-dialog
      title="选择报价公司"
      :visible.sync="showCompany"
      :width="getIsMobile?'100%':'70%'"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
      :append-to-body="false"
    >
      <QuotationCompany @selectedCompany="getCompany" />
    </el-dialog>
    <el-dialog  title="选择公司联系人"
                :visible.sync="showCompanyContact"
                :width="getIsMobile?'100%':'80%'"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                :before-close="handleCompanyContactClose"
                :append-to-body="false">
      <CompanyContacts v-if="showCompanyContact" ref="contactRef" :data="companyContact" @quotationContact="getSelectContacts" @getFirstContact="getFirstContact" />
    </el-dialog>
     <CompanyContacts v-if="flag" ref="contactRef" :data="companyContact" @quotationContact="getSelectContacts" @getFirstContact="getFirstContact"  />
  </div>
</template>
<script>
import { defineComponent, getCurrentInstance, reactive, ref, watch,nextTick } from '@vue/composition-api'
import useRootSetting from '@/hooks/useRootSetting'
import QuotationCompany from '@/views/createQuotation/quotationCompany.vue'
import Info from './info.vue'
import CompanyContacts from '@/components/Contacts/contacts.vue'
import request from "@/utils/request"
import { getToken } from '@/utils/auth'
export default defineComponent({
  name: 'CreateQuotation',
  components: { CompanyContacts, QuotationCompany, Info },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  setup(props, { emit }) {
    const { getIsMobile } = useRootSetting()
    const instance = getCurrentInstance()
    const username = instance.proxy.$store.getters.name
    const showCompany = ref(false) //显示报价公司
    const showInfo = ref(false) //显示公司的信息
    const contactRef = ref(null)
    const infoRef = ref(null)


    const list = ref([]) //格式化列表数据
    const companyInfo = reactive({
      name: '',
      id: ''
    })
    const companyContact = ref([])
    const renshui = ref('默认')
    const percentOptions = ref([
      { label: '+10%', value: 0.1 },
      { label: '+20%', value: 0.2 },
      { label: '+30%', value: 0.3 },
      { label: '+40%', value: 0.4 },
      { label: '+50%', value: 0.5 },
      { label: '+60%', value: 0.6 },
      { label: '-10%', value: -0.1 },
      { label: '-20%', value: -0.2 },
      { label: '-30%', value: -0.3 },
      { label: '-40%', value: -0.4 },
      { label: '-50%', value: -0.5 },
      { label: '-60%', value: -0.6 }
    ])

    //关闭报价公司弹窗
    const handleClose = () => {
      showCompany.value = false
      emit('close')
    }
  //动态计算型号表格的价格
    const calcPrice = (price, percent) => {
      const numPrice = Number(price)
      const numPercent = Number(percent)
      if (isNaN(numPrice)) return '0.00' // 价格为空时返回 0.00
      return (numPrice * (1 + numPercent)).toFixed(2)
    }
    watch(() => props.data, (newData) => {
      list.value = newData.map(row => ({
        ...row,
        renshui: '默认',  // 默认 0%，不影响原价
        price: row.price // 初始显示原价
      }))
    }, { immediate: true })
    const updatePrices = (row) => {
      row.price = calcPrice(row.price, row.renshui)
    }

   //打开报价公司弹窗
    const openCompany = () => {
      showCompany.value = true
    }

    //显示公司联系人
    const showCompanyContact = ref(false)
    const flag = ref(false)
    const getContact = async (showContact) => {
      if(showContact) {
        showCompanyContact.value = true
        if(showCompanyContact.value){
          nextTick(()=>{
            contactRef.value.getContract(companyInfo.id)
          })
        }
      }
    }
    const getCompany = ({company, cid}) => {
      showCompany.value = false
      showInfo.value = true
      companyInfo.id = cid
      companyInfo.name = company
      flag.value = true
      if(flag.value) {
        nextTick(()=>{
          contactRef.value.getContract(companyInfo.id)
        })
      }
    }
    //选择联系人给所有字段赋值
    const allInfo = reactive({
      dsname: '',
      dsbumen: '',
      dstel: '',
      dsphone: '',
      dsmax: '',
      dsemail: ''
    })
    //多条或单条联系人选择完后数据填充
    const getSelectContacts = (val) => {
      const {name,phone,bumen,max,email,tel,cid} = val
      allInfo.dsname = name
      allInfo.dsbumen = bumen
      allInfo.dsphone = phone
      allInfo.dsemail = email
      allInfo.dstel = tel
      allInfo.dsmax = max
      showCompanyContact.value = false
    }

    //选完报价公司后获取联系人的第一条数据填充
    const getFirstContact = (data) => {
      //有时候联系人没有值，防止默认上选选择公司填充的值，强制清除
      if(data.length == 0)   {
        Object.keys(allInfo).forEach(key => {
          allInfo[key] = "";
        });
      }
      const {name,phone,bumen,max,email,tel,cid} = data
      allInfo.dsname = name
      allInfo.dsbumen = bumen
      allInfo.dsphone = phone
      allInfo.dsemail = email
      allInfo.dstel = tel
      allInfo.dsmax = max
    }

    const handleCompanyContactClose = () => {
      showCompanyContact.value = false
    }

    //型号列表数量字段做验证
    const errors = ref({})
    const validateRow = (index, value) => {
      errors.value[index] = !value
    }

    //打印报价单
    const printQuotation = () => {
      let hasError = false
      errors.value = {} // 清空之前的错误状
      list.value.forEach((row, index) => {
        if (!row.num) {
          errors.value[index] = true
          hasError = true
        }
      })
      if (!hasError) {
        request({
          url:'print_quo.yy',
          method:'post',
          data: {
            username: username,
            ...infoRef.value.form,
            childdata: list.value
          }
        }).then(res => {
          if (res.code == 200) {
            window.open(`${res.url}&token=${getToken()}`)
          }
        })
      }
    }
    //做一个变量标识，如果有了接受人，立马把flag改为false，防止多余的组件显示
    const handleFlag = (newFlag) => {
      flag.value = newFlag
    }
    return {
      flag,
      infoRef,
      username,
      errors,
      allInfo,
      showCompanyContact,
      companyContact,
      companyInfo,
      showInfo,
      showCompany,
      list,
      renshui,
      percentOptions,
      getIsMobile,
      contactRef,
      handleFlag,
      handleCompanyContactClose,
      getFirstContact,
      getSelectContacts,
      getCompany,
      updatePrices,
      handleClose,
      calcPrice,
      openCompany,
      getContact,
      validateRow,
      printQuotation
    }
  }
})
</script>
<style scoped lang="scss">
.input-error {
  border: 1px solid red;
}
.error-text {
  color: red;
  font-size: 12px;
  margin-left: 5px;
}
</style>
